var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-container',[_c('v-card-title',[_vm._v(" Welcome ")]),_c('v-card-text',[_vm._v(" Check out the Structures menu on the top! ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }